import React from "react";
import { Link } from "react-router-dom";

// Uses the official OOHMA logo (transparent PNG) served from /public.
const Logo = ({ compact = false }) => {
  return (
    <Link to="/" className="inline-flex items-center select-none" aria-label="OOHMA Multimedia home">
      <img
        src="/oohma-logo.png"
        alt="OOHMA — Out of Home Media and Adtech"
        style={{
          height: compact ? 30 : 40,
          width: "auto",
          display: "block",
        }}
      />
    </Link>
  );
};

export default Logo;
